import styles from "./TrainerInfoPage.module.scss";
import {useNavigate, useParams} from "react-router-dom";
import {useEffect, useState} from "react";
import {IPublicTrainer} from "../../models/Trainer";
import useAppSelector from "../../hooks/useAppSelector";
import Spinner from "../../components/Spiner/Spinner";
import {getTrainerImage} from "../../helpers/image.helper";
import {useTranslation} from "react-i18next";
import backArrow from "../../assets/images/icons/arrow-left.svg";

const TrainerInfoPage = () => {

    const [currentTrainer, setCurrentTrainer] = useState<IPublicTrainer | null>(null);
    const {activeGym} = useAppSelector(state => state.multiGymsSlice);
    const {trainers, isTrainerLoading} = useAppSelector(state => state.trainersSlice);
    const {t} = useTranslation();
    const navigate = useNavigate();
    const {id} = useParams();

    useEffect(() => {
        if (!id) {
            navigate("/trainers");
            return;
        }
        if (!isTrainerLoading) {
            const trainer = trainers.find((t) => t.id === Number(id));
            if (trainer) {
                setCurrentTrainer(trainer);
            } else {
                navigate("/trainers");
            }
        }

    }, [id, isTrainerLoading])

    if (isTrainerLoading || !currentTrainer) {
        return (
            <Spinner/>
        )
    }


    return (
        <section className={styles.page}>
            <div className={"container"}>
                <button className={styles.backBtn} onClick={() => {
                    navigate("/trainers");
                }}>
                    <img src={backArrow} alt={"Back"}/>
                </button>
                <div className={styles.wrapper}>
                    <div className={styles.profileImage}
                         style={{backgroundImage: `url(${getTrainerImage(activeGym.endpoint, currentTrainer)})`}}></div>
                    <div className={styles.info}>
                        <h3 className={styles.name}>{currentTrainer.firstname} {currentTrainer.lastname}</h3>
                        {
                            currentTrainer.bio?.length && (
                                <>
                                    <p className={styles.bio}>{t("Bio")}</p>
                                    <p className={styles.text}>{currentTrainer.bio}</p>
                                </>
                            )
                        }
                    </div>
                </div>
            </div>
        </section>
    )
}

export default TrainerInfoPage;